import { render, staticRenderFns } from "./BundleView.vue?vue&type=template&id=347ab555&"
import script from "./BundleView.vue?vue&type=script&lang=js&"
export * from "./BundleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports